import React, { useEffect } from 'react';
import { ListGroup, Dropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import avatar1 from '../../../../assets/images/user/avatar-1.jpg';
import { getServerURL } from '../../../../helper/envConfig';
import { useDispatch, useSelector } from 'react-redux';
import { setLoginData } from '../../../../redux/action/LoginAction';
import api from '../../../../helper/api';

const NavRight = () => {

  const navigate = useNavigate();
  const serverURL = getServerURL();
  const dispatch = useDispatch()

  const profileData = useSelector((state) => state?.login);

  useEffect(() => {
    if (!Boolean(Object.keys(profileData)?.length)) { getProfileData(); }
  }, []);

  const getProfileData = () => {
    api
      .getWithToken(`${serverURL}auth/profile/`)
      .then(async (res) => {
        if (res?.data?.success === true) {
          dispatch(setLoginData(res?.data?.data))
        }
      })
      .catch((e) => {
      });
  };

  const handleLogout = () => {
    try {
      api
        .postWithToken(`${serverURL}auth/logout`)
        .then(async (res) => {
          if (res?.data?.success === true) {
            dispatch(setLogout());
            logout();
            navigate("/");
            if (typeof res?.data?.message === "string")
              toast.success(res?.data?.message);
            else toast.success("Logout Successfully");
          }
        })
        .catch((e) => {
        });
    } catch (error) { }
  };

  return (
    <React.Fragment>
      <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto" id="navbar-right">
        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown align="start" className="drp-user">
            <Dropdown.Toggle as={Link} variant="link" to="#" id="dropdown-basic">
              <i className="icon feather icon-settings" />
            </Dropdown.Toggle>
            <Dropdown.Menu align="end" className="profile-notification">
              <div className="pro-head">
                <img src={profileData?.profile_img || avatar1} className="img-radius" alt="User Profile" />
                <span>{profileData?.first_name || ""}</span>
                <Link to="/login" className="dud-logout" title="Logout">
                  <i className="feather icon-log-out" />
                </Link>
              </div>
              <ListGroup as="ul" bsPrefix=" " variant="flush" className="pro-body">

                <ListGroup.Item as="li" bsPrefix=" ">
                  <Link to="/profile" className="dropdown-item">
                    <i className="feather icon-user" /> Profile
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item as="li" bsPrefix=" ">
                  <Link to="/change-password" className="dropdown-item">
                    <i className="feather icon-lock" /> Change Password
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item as="li" bsPrefix=" ">
                  <Link to="/login" className="dropdown-item">
                    <i className="feather icon-log-out" /> Logout
                  </Link>
                </ListGroup.Item>
              </ListGroup>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
      </ListGroup>
    </React.Fragment>
  );
};

export default NavRight;
